// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"QuestionsList_settingsContainer__Bo2ko","dropdownBtn":"QuestionsList_dropdownBtn__bU3tK"};